import { Lease } from "./lease.model";
import { ApplicationType, OrderStatus, OrderType } from "./constants";
import { StringOrPhoneNumber } from "./common.model";
import { Field, ObjectType } from "./decorators";

/**
 * billing order model matching back-end tscommon module class.
 */
@ObjectType()
export class BillingOrder {

  @Field({q:['orderStatus', 'sdlist']}) public orderId!: number;
  @Field({q:['sdlist']}) public accountId?: number;
  @Field() public company?: string;
  @Field() public applicationType?: ApplicationType;
  @Field() public orderType?: OrderType;
  @Field({q:['orderStatus', 'sdlist']}) public orderStatus?: OrderStatus;
  @Field({q:['sdlist']}) public numberOfCodes = 0;
  @Field({q:['sdlist']}) public totalPrice = 0;
  @Field() public startDate?: Date;
  @Field() public endDate?: Date;
  @Field({q:['sdlist']}) public paymentDueDate?: Date;
  @Field({q:['sdlist']}) public paymentReceivedDate?: Date;
  @Field({q:['sdlist']}) public paymentMethod?: string;
  @Field({q:['sdlist']}) public paymentId?: number;
  @Field() public lastFourDigits?: string;
  @Field() public checkNumber?: string;
  @Field() public ccFailedAuthorization?: boolean;
  @Field() public ccFailedComment?: string;
  @Field() public poNumber?: string;
  @Field() public nsOfferType?: string;
  @Field() public nsSalesOrderId?: string;
  @Field() public nsSalesOrderInternalId?: string;
  @Field() public nsInvoiceInternalId?: string;
  @Field() public nsPaymentInternalId?: string;
  @Field() public createTime?: Date;
  @Field() public updateTime?: Date;
  @Field() public invoiceId?: number;
  @Field({q:['sdlist']}) public invoiceDate?: Date;
  @Field() public originalInvoiceDate?: Date;
  @Field() public invoiceVersion?: number;
  @Field({q:['sdlist']}) public invoiceDocumentId?: number;
  @Field({q:['sdlist']}) public receiptDocumentId?: number;
  @Field({q:['sdlist']}) public bulkReceiptDocumentId?: number;
  @Field() public billingFirstName?: string;
  @Field() public billingLastName?: string;
  @Field() public billingAddress1?: string;
  @Field() public billingAddress2?: string;
  @Field() public billingCity?: string;
  @Field() public billingZip?: string;
  @Field() public billingCountry?: string;
  @Field() public billingState?: string;
  @Field() public billingPhone?: StringOrPhoneNumber;
  @Field() public billingPhoneExtension?: string;
  @Field() public billingEmail?: string;

  public lines: Lease[] = [];
  public leases: Lease[] = [];

  public monthlyInvoiceId?: number;

  // client side fields to support webapp.
  public enrollInAutoRenew?: boolean;
  public enrollInMonthlyBilling?: boolean;


  // hash as computed by the back end.
  public pricingHash?: string;
  public isDiscounted = false;

  //For Monthly Billing enrollment when manual renew or 1 plus 12 when manual renew
  public monthlyBillingEligible?: boolean;
  public renew1Plus12?: boolean;
  public monBillStartDateStr?: string;
  public choseBilledMonthly?: boolean; // Only used on the UI side
  public renewalDeadLineStr?: string;
  public renewalAfterDeadline?: boolean;
  public bulkRenew?: boolean;
  public allMBDiscountsNotApplied?: boolean;

  // local
  public active?: boolean;
  public isInCart?: boolean;
  public selected?: boolean;
   // client only
   public isExpansionDisplay?: boolean;
}
